import { createCrudSagas } from './CrudSagas'
import { EntityTypesActions } from '../reducers/EntityTypesRedux'

const crudSagas = createCrudSagas('entityTypes', EntityTypesActions)

export const findEntityTypes = crudSagas.findEntityTypes
export const getEntityType = crudSagas.getEntityType
export const updateEntityType = crudSagas.updateEntityType
export const watchEntityTypes = crudSagas.watchEntityTypes
export const createEntityType = crudSagas.createEntityType
